import React from "react";

const CustomProgressBar = ({ progress }) => {
  return (
    <div
      style={{
        width: "100%", // Make the progress bar fill its parent container
        height: "20px",
        backgroundColor: "#e9ecef", // Light gray background
        borderRadius: "10px",
        overflow: "hidden",
        position: "relative",
        marginTop: "10px", // Adds a little spacing
      }}
    >
      {/* Inner Fill */}
      <div
        style={{
          width: `${progress}%`,
          height: "100%",
          backgroundColor: "#28a745", // Green fill color
          transition: "width 0.3s ease-in-out",
        }}
      ></div>

      {/* Progress Label */}
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "50%",
          transform: "translateX(-50%)",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          fontWeight: "bold",
          color: "#fff",
        }}
      >
        {Math.round(progress)}%
      </div>
    </div>
  );
};

export default CustomProgressBar;
